import {Button, Tooltip} from "antd";
import {useMemo, useState} from "react";
import { useSteps } from "../../../hooks/useSteps";
import { BigInput } from "../../../components/forms/bigInput/BigInput";
import SegmentBuilderIllustration from "../../../assets/illustrations/SegmentBuilderIllustration";
import TextAreaNext from "../../../components/forms/textAreaNext/TextAreaNext";
import LongArrowRight from "../../../assets/icons/LongArrowRight";

interface SegmentDetailsStepProps {
    onClose: () => void;
    title: string;
    setTitle: (newVal: string) => void;
    description: string;
    setDescription: (newVal: string) => void;
    isSubmitting: boolean;
    isNew?: boolean;
}

const SegmentDetailsStep = ({ isNew = true, onClose, title, setTitle, description, setDescription, isSubmitting }: SegmentDetailsStepProps) => {
    const { goNext } = useSteps();

    const submitSegmentDetails = () => {
        if(!isDisabled) {
            goNext();
        }
    }

    const isDisabled = !title || !description;

    return (
        <div>
            <div className="segment-details-form-container">
                <div className="segment-details-form">
                    <div className="sub-title">
                        <div>Give your segment a clear name and description.</div>
                        <div>This helps you quickly identify it when managing campaigns.</div>
                    </div>
                    <BigInput value={title} setValue={setTitle} placeholder="My new segment title" maxLength={99} />
                    <TextAreaNext label="My new segment description" value={description} setValue={setDescription} />
                </div>
                <div className="segment-illustration-container">
                    <SegmentBuilderIllustration />
                </div>
            </div>
            {isNew ?
                <div className="modal-footer">
                    <div className="flex actions">
                        <Button size="large" type="default" onClick={onClose}>Cancel</Button>
                        <Tooltip title={isDisabled ? 'Please add a title and description to continue.' : ''}>
                            <Button size="large" type="primary" disabled={isDisabled} onClick={submitSegmentDetails} iconPosition="end" icon={<LongArrowRight width={14} color='#fff' />}>Next</Button>
                        </Tooltip>
                    </div>
                </div>
            : null}
        </div>
    );
}

export default SegmentDetailsStep;